/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SelectItem
 */
export interface SelectItem {
    /**
     * 
     * @type {string}
     * @memberof SelectItem
     */
    idValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SelectItem
     */
    displayValue?: string | null;
}

/**
 * Check if a given object implements the SelectItem interface.
 */
export function instanceOfSelectItem(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SelectItemFromJSON(json: any): SelectItem {
    return SelectItemFromJSONTyped(json, false);
}

export function SelectItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SelectItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idValue': !exists(json, 'idValue') ? undefined : json['idValue'],
        'displayValue': !exists(json, 'displayValue') ? undefined : json['displayValue'],
    };
}

export function SelectItemToJSON(value?: SelectItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idValue': value.idValue,
        'displayValue': value.displayValue,
    };
}

